import { Col } from "react-bootstrap";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import "./ProfilePagination.css";
import React from "react";

const ProfilePagination = ({
    activeTab,
    totalOnDemandPages,
    totalDownloadPages,
    handlePageChange,
    currentPage,
    totalItems,
    isLoading,
}) => {
    const numPages = React.useMemo(
        () =>
            (activeTab === "orders" ? totalOnDemandPages : totalDownloadPages),
        [activeTab, totalDownloadPages, totalOnDemandPages]
    );

    const goToNext = () => handlePageChange(currentPage + 1);
    const goToPrevious = () => handlePageChange(currentPage - 1);

    return (
        <Col>
            <div className="d-flex justify-content-center align-items-center">
                <button
                    type="button"
                    className={"page-nav-btn remove-btn-defaults pl-0" + (isLoading ? " deactivated" : null)}
                    disabled={currentPage === 1}
                    onClick={goToPrevious}
                >
                    <MdKeyboardArrowLeft fill="#9A9BA6" />
                </button>

                <p className="nav-paragraph m-0">
                    {`Page ${currentPage} of ${numPages}`}
                    <br />
                    {`${totalItems} Results`}
                </p>

                <button
                    type="button"
                    className={"page-nav-btn remove-btn-defaults pr-0" + (isLoading ? " deactivated" : null)}
                    disabled={currentPage === numPages}
                    onClick={goToNext}
                >
                    <MdKeyboardArrowRight fill="#9A9BA6" />
                </button>
            </div>
        </Col>
    );
};

export default ProfilePagination;
